module.exports = __webpack_public_path__ + "img/1327086927.90f66807.jpg";